import { put, takeEvery } from "redux-saga/effects";
import * as types from "../types";
import { ROLE_ACCESS } from "utils/Utils";
import {
  getAnalyticsApiData, getAnalyticsCallBreakDownApi, editAnalyticsDataApi,getAnalyticsCallUnansweredApi,getAnalyticsCallOverviewApi

} from "redux/agent";

function* getAnalyticsDataSaga(action) {
  console.log("getAnalyticsDataSaga Invoked",action)

  try {
    yield put({
      type: types.SET_LOADER,
      payload: true,
    });
    let response = yield getAnalyticsApiData(action.payload);

    yield put({
      type: types.GET_ANALYTICS_DATA_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    console.log("err", error);
    if((error.response.status === 400 && error.response.data.message==='Invalid token') || (error.response.status === 403 &&
      error.response.data.message === "Invalid token")){
      yield put({
        type: types.USER_LOGOUT,
      });
    }
    else{
      yield put({
        type: types.GET_ANALYTICS_DATA_FAILED,
        payload: { status: 'failed' },
      });
    }

  }
  finally{
    yield put({
      type: types.SET_LOADER,
      payload: false,
    });
  }
}





function* getAnalyticsCallBrkDwnDataSaga(action) {
  console.log("getAnalyticsCallBrkDwnDataSaga Invoked")


  try {
    let response = yield getAnalyticsCallBreakDownApi(action.payload);

    yield put({
      type: types.GET_ANALYTICS_CALL_BREAK_DOWN_DATA_SUCCESS,
      payload: response.data,
    });
  } catch (err) {
    console.log("err", err);
    console.log("err========/n=========", err);

    yield put({
      type: types.GET_ANALYTICS_CALL_BREAK_DOWN_DATA_FAILED,
      payload: { status: 'failed' },
    });
  }
}

function* getAnalyticsCallOverviewDataSaga(action) {
  console.log("getAnalyticsCallOverviewDataSaga Invoked")


  try {
    let response = yield getAnalyticsCallOverviewApi(action.payload);

    yield put({
      type: types.GET_ANALYTICS_CALL_BREAK_DOWN_DATA_SUCCESS,
      payload: response.data,
    });
  } catch (err) {
    console.log("err", err);
    console.log("err========/n=========", err);

    yield put({
      type: types.GET_ANALYTICS_CALL_BREAK_DOWN_DATA_FAILED,
      payload: { status: 'failed' },
    });
  }
}

function* getAnalyticsUnansweredDataSaga(action) {
  console.log("getAnalyticsUnansweredDataSaga Invoked",action)

  try {
    yield put({
      type: types.SET_LOADER,
      payload: true,
    });
    let response = yield getAnalyticsCallUnansweredApi(action.payload);

    yield put({
      type: types.GET_ANALYTICS_UNANSWERED_DATA_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    console.log("err", error);
    if((error.response.status === 400 && error.response.data.message==='Invalid token') || (error.response.status === 403 &&
      error.response.data.message === "Invalid token")){
      yield put({
        type: types.USER_LOGOUT,
      });
    }
    else{
      yield put({
        type: types.GET_ANALYTICS_UNANSWERED_DATA_FAILED,
        payload: { status: 'failed' },
      });
    }

  }
  finally{
    yield put({
      type: types.SET_LOADER,
      payload: false,
    });
  }
}




function* putAnalyticsDataChange(action) {

  try {
    let response = yield editAnalyticsDataApi(action.payload);

    yield put({
      type: types.PUT_EDIT_ANALYTICS_DATA_SUCCESS,
      payload: { isDataUpdated: true },
    });

    yield put({
      type: types.OPEN_UPDATE_MODAL,
      payload: "Analytics data updated successfully",
    });


  } catch (err) {
    console.log("err", err);

    yield put({
      type: types.PUT_EDIT_ANALYTICS_DATA_FAILED,
      payload: { isDataUpdated: false },
    });
  }
}

function* getAnalytics() {
  yield takeEvery(
    types.GET_ANALYTICS_DATA,
    getAnalyticsDataSaga
  );


  yield takeEvery(
    types.GET_ANALYTICS_CALL_BREAK_DOWN_DATA,
    getAnalyticsCallBrkDwnDataSaga
  );

  yield takeEvery(
    types.GET_ANALYTICS_UNANSWERED_DATA,
    getAnalyticsUnansweredDataSaga
  );
  yield takeEvery(
    types.PUT_EDIT_ANALYTICS_DATA,
    putAnalyticsDataChange
  );
  yield takeEvery(
    types.GET_ANALYTICS_CALL_OVERVIEW_DATA,
    getAnalyticsCallOverviewDataSaga
  );
  

}

export default getAnalytics;
